import loadable from '@/lib/loadable';
import AuthMiddleware from '@/middlewares/AuthMiddleware';
import GuestMiddleware from '@/middlewares/GuestMiddleware';
import RolesMiddleware from '@/middlewares/RolesMiddleware';
import { wrapCreateBrowserRouterV6 } from '@sentry/react';
import { createBrowserRouter, Navigate, RouteObject } from 'react-router';

//* auth
const SignIn = loadable(() => import('@/pages/auth/SignIn'), 'h-screen');
const ForgetPassword = loadable(() => import('@/pages/auth/ForgetPassword'), 'h-screen');

//* dashboard
const Dashboard = loadable(() => import('@/pages/dashboard'));

//* Machines management
const Machines = loadable(() => import('@/pages/machines/index'));
const AddMachine = loadable(() => import('@/pages/machines/add-machine/AddMachine'));
const SingleMachine = loadable(() => import('@/pages/machines/single-machine/index'));

//* Energie
const Energie = loadable(() => import('@/pages/energie'));
const EnergieDetails = loadable(() => import('@/pages/energie/details'));

//* Frigos
const Frigos = loadable(() => import('@/pages/frigos'));
const FrigosDetails = loadable(() => import('@/pages/frigos/details'));

//* Capteurs management
// const Capteurs = loadable(() => import('@/pages/capteurs/index'));

// * Notifications
// const NotificationsPage = loadable(() => import('@/pages/notifications/index'));

// * UserManagement
const UserManagement = loadable(() => import('@/pages/user-management'));

// * Settings
const Settings = loadable(() => import('@/pages/settings'));
const Account = loadable(() => import('@/pages/settings/account'));
const Security = loadable(() => import('@/pages/settings/security'));
const NotificationsSettings = loadable(() => import('@/pages/settings/notifications'));

//* Not found
const NotFound = loadable(() => import('@/components/app/NotFound'));

//* Server error
const ErrorBoundary = loadable(() => import('@/routes/ErrorBoundary'));

const sentryCreateBrowserRouter = wrapCreateBrowserRouterV6(createBrowserRouter);

const routes: RouteObject[] = [
  {
    path: '/auth',
    element: <GuestMiddleware />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: 'sign-in',
        element: <SignIn />,
      },
      {
        path: 'forget-password',
        element: <ForgetPassword />,
      },
    ],
  },
  {
    path: '/',
    errorElement: <ErrorBoundary />,
    element: <AuthMiddleware />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        element: <RolesMiddleware asParentRoute roles={['admin']} />,
        children: [
          {
            path: '/utilisateur',
            element: <UserManagement />,
          },
          {
            path: '/machines/add',
            element: <AddMachine />,
          },
        ],
      },
      {
        path: '/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/machines',
        element: <Machines />,
      },
      {
        path: '/machines/:id',
        element: <SingleMachine />,
      },
      {
        path: '/energie',
        element: <Energie />,
      },
      {
        path: '/energie/:centraleId',
        element: <EnergieDetails />,
      },
      {
        path: '/frigos',
        element: <Frigos />,
      },
      {
        path: '/frigos/:tunnelId',
        element: <FrigosDetails />,
      },
      // {
      //   path: '/notifications',
      //   element: <NotificationsPage />,
      // },
      // {
      //   path: '/capteurs',
      //   element: <Capteurs />,
      // },
      {
        path: '/settings',
        element: <Settings />,
        children: [
          {
            path: '/settings/account',
            element: <Account />,
          },
          {
            path: '/settings/security',
            element: <Security />,
          },
          {
            path: '/settings/notifications',
            element: (
              <RolesMiddleware roles={['admin']}>
                <NotificationsSettings />
              </RolesMiddleware>
            ),
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: (
      <div className="h-screen flex items-center justify-center">
        <NotFound />
      </div>
    ),
  },
];

const router = sentryCreateBrowserRouter(routes);
// const router = createBrowserRouter(routes);

export default router;
